import { applyUTMsToLinksAndForms } from "./applyUTMs";

export function retryApplyUTMs({ debug = false }: { debug?: boolean }) {
  const delays = [2000, 3000, 5000, 9000]; // ms

  delays.forEach((delay) => {
    setTimeout(() => {
      applyUTMsToLinksAndForms({ debug });
    }, delay);
  });
}
